import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ScanLine, BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import WarrantyView from "@/components/WarrantyView";

export default function WarrantyCheck() {
  const { serial } = useParams();
  const { lang, user } = useApp();
  const nav = useNavigate();
  const [code, setCode] = useState(serial || "");
  const [w, setW] = useState(null);
  const [err, setErr] = useState("");
  const [hidden, setHidden] = useState(false);
  const id = lang === "id";
  useEffect(() => {
    const off = () => setHidden(true);
    const on = () => setHidden(false);
    const key = (e) => { if (e.key === "PrintScreen" || ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p")) { e.preventDefault(); off(); setTimeout(on, 1500); } };
    window.addEventListener("blur", off); window.addEventListener("focus", on); window.addEventListener("keyup", key); window.addEventListener("keydown", key);
    return () => { window.removeEventListener("blur", off); window.removeEventListener("focus", on); window.removeEventListener("keyup", key); window.removeEventListener("keydown", key); };
  }, []);
  useEffect(() => {
    setW(null); setErr("");
    if (serial) { api.get(`/warranty/${serial}`).then((r) => setW(r.data)).catch(() => setErr("Certificate not found. This product could not be verified as authentic.")); }
  }, [serial]);
  const submit = (e) => { e.preventDefault(); if (code.trim()) nav(`/warranty/${code.trim().toUpperCase()}`); };
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-14 space-y-8" data-testid="warranty-check-page">
      <div className="space-y-3">
        <p className="font-mono text-xs tracking-[0.25em] text-[#8C4F27]">CERTIFICATE VERIFICATION</p>
        <h1 className="font-serif text-4xl sm:text-5xl">Authentication & Warranty</h1>
        <p className="text-[#6E6259] flex items-center gap-2"><ScanLine size={16} />{id ? "Scan QR code di sertifikat atau masukkan nomor seri untuk cek keaslian dan garansi." : "Scan the QR code on the certificate or enter the serial number to verify authenticity and warranty."}</p>
      </div>
      <form onSubmit={submit} className="flex border border-[#E6DFD5] bg-white">
        <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="CEW-2610-XXXXXX" className="flex-1 px-4 py-3 outline-none bg-transparent font-mono uppercase" data-testid="warranty-code-input" />
        <button className="bg-[#3B220C] text-white px-6 text-sm" data-testid="warranty-check-btn">{id ? "Cek" : "Check"}</button>
      </form>
      {err && <p className="text-[#9E2A2B]" data-testid="warranty-not-found">{err}</p>}
      {w && <p className="flex items-center gap-2 text-[#2E7D32] font-medium tracking-wide" data-testid="authentic-badge"><BadgeCheck size={20} />AUTHENTIC CRAFTENDEMIC PRODUCT — certificate verified</p>}
      {w && <div data-protect className={`select-none print:hidden transition-[filter] ${hidden && !user ? "blur-xl" : ""}`}><WarrantyView w={w} canPrint={!!w.can_print} /></div>}
      {w && !w.can_print && <p className="text-xs text-[#6E6259]" data-testid="warranty-print-login-note">{id ? "Masuk ke akun untuk mencetak kartu garansi." : "Sign in to print the warranty card."}</p>}
    </div>
  );
}
